import { styled, Tab, Tabs, Theme } from '@mui/material';

export const sxStyles = {
  pageTitle: {
    margin: '1.25rem 0',
  },
  infoItemTitle: {
    marginRight: '4px',
  },
  infoItemValue: (theme: Theme) => ({
    color: theme.palette.grey['600'],
    lineHeight: '1.5rem',
  }),
};

export const StyledHeadSectionInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '0 2.5rem 3rem',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  [theme.breakpoints.down('xs')]: {
    padding: '0 1.25rem',
  },
}));

export const StyledHeadInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',

  '& > button:first-of-type': {
    marginRight: '1rem',
  },

  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
  },
}));

export const StyledCommonAppId = styled('div')(() => ({
  display: 'flex',

  '& > div:first-of-type': {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '4px',
    marginBottom: '2px',

    ':hover': {
      cursor: 'pointer',
    },
  },
}));

export const StyledInfoItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '0 1rem',
  borderLeft: `1px solid ${theme.palette.grey['300']}`,

  '& > div:first-of-type': {
    display: 'flex',
    marginRight: '0.5rem',
  },

  [theme.breakpoints.down('xs')]: {
    padding: '0.5rem 0',
    borderLeft: 'none',
  },
}));

export const StyledTab = styled(Tab)(() => ({
  fontSize: '0.938rem',
  fontWeight: 500,
  height: '54px',
}));

export const StyledTabLabel = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',

  '& > svg:first-of-type': {
    width: '24px',
    height: '24px',
    marginRight: '0.5rem',
  },
}));

export const StyledTabs = styled(Tabs)(() => ({
  '& .MuiTabs-flexContainer': {
    justifyContent: 'space-around',
  },
}));
